module.exports = __webpack_public_path__ + "img/006.1dc299eb.png";